import { pipe, tap } from 'wonka';
import { Exchange } from 'urql';
import { HeaderKeys } from '@watershed/shared-universal/utils/constants';

export type SessionLevelEscapeHatchExchange = (
  sessionLevelEscapeHatch: boolean
) => Exchange;

const sessionLevelEscapeHatchExchange: SessionLevelEscapeHatchExchange =
  (sessionLevelEscapeHatch): Exchange =>
  ({ forward }) => {
    return (ops$) =>
      sessionLevelEscapeHatch
        ? pipe(
            ops$,
            tap((op) => {
              if (typeof op.context.fetchOptions === 'function') {
                op.context.fetchOptions = op.context.fetchOptions();
              }

              op.context.fetchOptions = {
                ...(op.context.fetchOptions || {}),
                headers: {
                  ...(op.context.fetchOptions?.headers || {}),
                  [HeaderKeys.escapeHatchSessionLevel]: 'true',
                },
              };
            }),
            forward
          )
        : forward(ops$);
  };

export default sessionLevelEscapeHatchExchange;
